// React
import { FunctionComponent, useMemo } from "react";
import dayjs from "dayjs";
import { CqlMeasureConfiguration } from "@fyrstain/fhir-front-library";
// Components
import JupiterPage from "../../components/JupiterPage/JupiterPage";
// Style
import styles from "./Statistics.module.css";
// Translation
// import i18n from "i18next";
import MultiboardContainer2 from "../../containers/MultiboardContainer2";

const Statistics: FunctionComponent = () => {
    const today = dayjs().format("YYYY-MM-DD");
    const librarySource = process.env.REACT_APP_FHIR_URL ?? "";
    const defaultCqlConfiguration = useMemo<CqlMeasureConfiguration>(() => ({
        cqlServer: process.env.REACT_APP_CQL_ENGINE_URL || undefined,
        dataEndpoint: process.env.REACT_APP_CQL_DATA_ENDPOINT || librarySource,
        terminologyEndpoint:
            process.env.REACT_APP_CQL_TERMINOLOGY_ENDPOINT || librarySource,
        contentEndpoint: process.env.REACT_APP_CQL_CONTENT_ENDPOINT || librarySource,
    }), [librarySource]);

    return (
        <JupiterPage
            titleKey='title.statistics'
            loading={false}
            fitFooter={false}
            needsLogin={true}
        >
            <>
                <div data-testid="stat-board"className={styles.percentageContainer}>
                    <MultiboardContainer2
                        librarySource={librarySource}
                        periodStart="2010-01-01"
                        periodEnd={today}
                        defaultCqlConfiguration={defaultCqlConfiguration}
                        // language={i18n.t}
                        onError={() => { }}
                    />
                </div>
            </>
        </JupiterPage>
    );
};

export default Statistics;
